import { WORKSPACELIST } from "../../actions/workspace/";

export default function(state = [], action) {
  switch (action.type) {
    case WORKSPACELIST:
      return action.payload;
    default:
  }

  return state;
}
